import React from 'react'
import DialogSearchComponent from '../components/DialogSearchComponent'

const DialogSearch = ({
  dialog,
  setDialog,
  search,
  clearSearch,
  searchState,
  setSearchState,
}) => {
  return (
    <DialogSearchComponent
      dialog={dialog}
      setDialog={setDialog}
      searchState={searchState}
      setSearchState={setSearchState}
      search={search}
      clearSearch={clearSearch}
    />
  )
}

export default DialogSearch
